export default "__VITE_PUBLIC_ASSET__099bc268__"